/**
 * Sponsor / partner strip config.
 *
 * The principal identity mark (Sikhio municipal seal) is rendered as its
 * own slot in the topbar — the rest of the strip used to be hardcoded
 * JSX in TopBar.tsx. Adding a new partner required a code change.
 *
 * To add/remove/reorder a partner: edit SPONSORS only. The topbar reads
 * this array and renders one <a> per entry.
 *
 * The seal is intentionally NOT in this list — it is the municipality's
 * own mark, not a partner, and is rendered with a distinct larger slot.
 */

export interface Sponsor {
  /** Visible display name in the tooltip / aria-label. Thai canonical. */
  name: string;
  /** English short name (for the aria-label fallback). */
  nameEn: string;
  /** Logo asset path under /public. */
  logo: string;
  /** External partner URL. */
  href: string;
  /** CSS class hook for any layout-specific styling (size, position). */
  cssClass?: string;
}

export const SPONSORS: Sponsor[] = [
  {
    name: "depa · สำนักงานส่งเสริมเศรษฐกิจดิจิทัล",
    nameEn: "depa — Digital Economy Promotion Agency",
    logo: "/logos/depa.jpg",
    href: "https://www.depa.or.th",
  },
  {
    name: "Smart City Thailand · สมาร์ตซิตี้ไทยแลนด์",
    nameEn: "Smart City Thailand",
    logo: "/logos/smart-city-thailand.jpg",
    href: "https://www.smartcitythailand.or.th",
  },
  {
    name: "Axiom · นวัตกรรมในฐานะบริการ",
    nameEn: "Axiom — Innovation as a Service",
    logo: "/logos/axiom.png",
    href: "https://axiom.nonarkara.org",
    cssClass: "sponsor-axiom",
  },
];
